var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none",
      fillRule: "nonzero"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.057,3.252L9,3.25L5,3.25C3.491,3.25 2.25,4.491 2.25,6C2.25,6.015 2.25,6.03 2.251,6.045C2.762,14.456 9.544,21.238 17.955,21.749C17.97,21.75 17.985,21.75 18,21.75C19.509,21.75 20.75,20.509 20.75,19L20.75,15C20.75,14.693 20.563,14.418 20.279,14.304L15.279,12.304C14.937,12.167 14.546,12.298 14.357,12.614L13.224,14.502C11.679,13.606 10.394,12.321 9.498,10.776C9.498,10.776 11.386,9.643 11.386,9.643C11.702,9.454 11.833,9.063 11.696,8.721L9.696,3.721C9.59,3.455 9.341,3.274 9.057,3.252ZM5,4.75C4.321,4.75 3.762,5.302 3.75,5.984C4.229,13.619 10.385,19.773 18.029,20.25C18.702,20.234 19.25,19.676 19.25,19C19.25,19 19.25,15.508 19.25,15.508C19.25,15.508 15.314,13.934 15.315,13.934L14.143,15.886C13.942,16.221 13.518,16.345 13.168,16.173C10.849,15.029 8.971,13.151 7.827,10.832C7.655,10.482 7.779,10.058 8.114,9.857C8.114,9.857 10.066,8.685 10.066,8.685C10.066,8.685 8.492,4.75 8.492,4.75L5,4.75Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.4d2b1965.svg";
export { ForwardRef as ReactComponent };